export function isIFrame() {
  try {
    return window.self !== window.parent;
  } catch (e) {
    return true;
  }
}
